import { render, staticRenderFns } from "./advanced.vue?vue&type=template&id=3cd8b5f8&"
import script from "./advanced.vue?vue&type=script&lang=js&"
export * from "./advanced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports